import * as CarouselElements from 'react-aria-carousel';
import styled from 'styled-components';

export const Carousel = styled(CarouselElements.Carousel)`
  position: relative;
  width: 100%;
`;

export const Track = styled(CarouselElements.CarouselScroller)<{ $scroll?: boolean }>`
  display: grid;
  grid-auto-flow: column;
  justify-content: ${({ $scroll }) => ($scroll ? 'start' : 'center')};
  gap: 12px;
  margin-inline: 44px;
  overflow: auto;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  &::-webkit-scrollbar { display: none; }
  & [data-carousel-item] > * { width: 100%; height: 100%; }
  &:focus-visible {
    box-shadow: var(--shadow-focus);
    outline: 0;
  }

  @media (width < 64rem) {
    margin-inline: 0;
  }
`;

export const Arrow = styled(CarouselElements.CarouselButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid var(--black);
  background: var(--white);
  color: var(--black);
  cursor: pointer;
  z-index: 4;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &[data-direction='prev'] { left: 0; }
  &[data-direction='next'] { right: 0; }

  &:hover {
    background: var(--grey-50);
  }
  &:focus-visible {
    box-shadow: var(--shadow-focus);
    outline: 0;
  }
  &:disabled,
  &[aria-disabled='true'] {
    border-color: var(--grey-300);
    background: var(--grey-50);
    cursor: default;
  }

  & svg { width: 20px; height: 20px; }

  @media (width < 64rem) {
    display: none;
  }
`;

const cardBase = `
  display: flex;
  flex-direction: column;
  border-radius: var(--radius-xlarge, 12px);
  padding-bottom: 12px;
  overflow: hidden;
  text-decoration: none;
`;

export const Card = styled.div`
  ${cardBase}
`;

export const ImageLink = styled.a`
  display: block;
  text-decoration: none;
`;

export const ImageBox = styled.div`
  width: 100%;
  background: var(--grey-100);
`;

export const Img = styled.img`
  width: 100%;
  object-fit: cover;
  display: block;
`;

export const Title = styled.div`
  margin: 12px 0 12px 0;
  font-size: var(--font-size-text-md);
  font-weight: var(--font-weight-bold);
  line-height: 1.25;
  color: var(--black);
`;

export const Description = styled.div`
  margin: 0 11px 4px;
  font-size: var(--font-size-text-md);
  line-height: 1.4;
  color: var(--grey-700);
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  & a { color: var(--grey-700); text-decoration: none; }
  & a:hover { text-decoration: underline; }
  & p { margin: 0; }
`;

export const LinkRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin-inline: 11px;
  font-size: var(--font-size-text-xs, 0.75rem);
  font-weight: var(--font-weight-medium);
  color: var(--grey-700);
  & svg { flex: 0 0 13px; width: 13px; height: 13px; color: var(--grey-500); }
`;
